<template>
  <section class="sub-page iframe">
    <top-section
      :navs="navs"
      :title="nav_title"
    />

    <!-- <div
      v-if="!iframe.loaded"
      class="m-5 p-5 text-center"
    >
      <b-spinner
        class="m-5 p-5"
        variant="success"
        size="12rem"
      />
    </div>

    <iframe
      v-show="iframe.loaded" 
      id="housing__data__dashboard"
      ref="housing__data__dashboard"
      :src="iframe.src"
      scrolling="no"
      title="Housing Data"
      rameborder="0"
      allowFullScreen="true"
      style="width:100%; min-height:1450px; border:0; overflow: hidden;"
      @load="load"
    /> -->

    <div class="mb-5 mx-5">
      <div class="text-center">
        <p class="font-semibold pb-4 text-3xl">
          HMIP | GRID3
        </p>
      </div>
      <button
        class="bg-[#1cfa78] py-2 text-[#262637] px-4 rounded-sm m-2"
        @click="filter('boundary')"
      >
        NGA Boundary
      </button>

      <button
        style="background-color: #2c83fb; color: white;"
        class="bg-[#2c83fb] py-2 text-[#262637] px-4 rounded-sm m-2"
        @click="filter('health')"
      >
        Health Facility
      </button>



      <div class="mt-4 justify-between gap-4 md:flex-row flex mx-20 flex-col mx-auto">
        <div class="md:w-3/3 w-full">
          <div
            style="background-color: #276c43"
            class="flex flex-col gap-y-1 text-white p-1 bg-[#276c43] rounded-lg"
          >
            <div
              v-if="LGA.length == 0"
              class="w-[100%] md:w-[100%] mx-auto"
            >
              <p
                v-if="report == 'health' || report == 'all'"
                class="pb-1 pt-2 text-lg text-white transition-all duration-300 text-center "
              >
                Health Facilities
              </p>
              <button
                v-if="report == 'health' || report == 'all'"
                class="bg-[#1cfa78] py-2 text-[#262637] px-4 rounded-sm m-2"
                @click="downloadH()"
              >
                Download Data Set
              </button>

              <iframe
                v-if="report == 'health' || report == 'all'"
                title="Health Facilities v2.0"
                width="1000"
                height="480"
                class="materialsPrice"
                src="https://app.powerbi.com/view?r=eyJrIjoiNDA3YzAyNDQtMDg4Mi00OTdjLTgxMDgtNTIyOWFiYjdlZmQ1IiwidCI6ImE4MTNjYTk4LWU0MTMtNDJkMS1iNzNmLTlmZGM3YTJhYjhkNCIsImMiOjh9"
                frameborder="0"
                allowFullScreen="true"
              />

              <p
                v-if="report == 'boundary' || report == 'all'"
                class="pb-1 pt-2 text-lg text-white transition-all duration-300 text-center "
              >
                NGA Boundary
              </p>
              <button
                v-if="report == 'boundary' || report == 'all'"
                class="bg-[#1cfa78] py-2 text-[#262637] px-4 rounded-sm m-2"
                @click="download()"
              >
                Download Data Set
              </button>

              <iframe
                v-if="report == 'boundary' || report == 'all'"
                title="NGA boundary"
                width="1000"
                height="480"
                class="materialsPrice"
                src="https://app.powerbi.com/view?r=eyJrIjoiZmQzNTAzNDctYjRkNi00MWRkLTliMDAtNWQ4YTgxMWMzY2FmIiwidCI6ImE4MTNjYTk4LWU0MTMtNDJkMS1iNzNmLTlmZGM3YTJhYjhkNCIsImMiOjh9"
                frameborder="0"
                allowFullScreen="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Form from "vform";
import TopSection from "../../components/General/TopSection.vue";
import states from "../states.json";
import LGA from "../LGA.json";

export default {
  name: "HousingDashboard",
  components: { TopSection },

  data: () => ({
    nav_title: "Datasets",
    navs: [
      {
        route_name: "home",
        route_title: "Home",
      },
      {
        route_name: "dashboard",
        route_title: "Dashboards",
      },
      {
        route_name: "dashboard.grid3",
        route_title: "Grid3 Data",
        active: true,
      },
    ],
    dataset_dir: '../../assets/datasets/',
    states: states,
    originalLGA: LGA,
    LGA: [],
    report: "all",
    visible: true,
    iframe: {
      src: "https://app.powerbi.com/view?r=eyJrIjoiNmNiNmI1MzMtYjI5ZS00ZmUwLThlNTUtYjdiMTU3YmRjNDhmIiwidCI6ImE4MTNjYTk4LWU0MTMtNDJkMS1iNzNmLTlmZGM3YTJhYjhkNCIsImMiOjh9",
      loaded: false,
    },
    form: new Form({
      state: "",
      LGA: "",
      noOfBeds: "",
      quarter: "",
      year: "",
    }),
  }),
  watch: {
    "form.state": function () {
      this.filter();
    },
  },

  methods: {
    load() {
      this.iframe.loaded = true;
    },

    download() {
      var file_path = this.dataset_dir + 'NGA_State_Boundaries_V2_-8716175482902759485.xlsx';
      window.open(file_path);
    },
    downloadH() {
      var file_path = this.dataset_dir + 'GRID3_NGA_health_facilities_v2_0_-8505043833102029199.xlsx';
      window.open(file_path);
    },
    filter(report) {
      this.report = report;
      let selectedState = this.form.state.stateName?.toLocaleLowerCase();
      let selectedYear = this.form.year;
      let selectedQuarter = this.form.quarter;
      let selectedLGA = this.form.LGA;
      let selectedNoOfBeds = this.form.noOfBeds;

      if (selectedState) {
        this.LGA = this.originalLGA.filter((x) => {
          return x.state?.toLocaleLowerCase() === selectedState;
        });
      } else {
        this.LGA = [];
      }

      if (selectedYear) {
        this.LGA = this.LGA.filter((x) => x.year == selectedYear);
      }
      if (selectedLGA) {
        this.LGA = this.LGA.filter((x) => x.LGA == selectedLGA);
      }
      if (selectedQuarter) {
        this.LGA = this.LGA.filter((x) => x.quarter == selectedQuarter);
      }
      if (selectedNoOfBeds) {
        this.LGA = this.LGA.filter((x) => x.noOfBeds == selectedNoOfBeds);
      }
    },
  },
};
</script>
<style scoped>
.iframe {
  overflow-y: hidden;
}

.materialsPrice {
  zoom: 1.2
}
</style>
